// extracted by mini-css-extract-plugin
module.exports = {"square-body":"SquareBody-module__square-body___2iI5j"};